module.exports = __webpack_public_path__ + "static/img/home_bg2.848e1006.jpg";